'use strict';

class Sticky {
	constructor(el){
		this.el = el;
		this.isSticky = false;
		this.isFirst = false;
		this.topPx = 0;      // is-sticky のときの top(px)。static の間は最後の値を使い回す
		this.pending = null; // 追従中で切り替えを保留した状態
		this.initialized = false;
		this.onScroll = this.onScroll.bind(this);
	}

	// 追従が始まる位置（px）。切り替えても見た目が動かないかの判定に使う
	stickyTop(){
		const t = parseFloat(getComputedStyle(this.el).top);
		if( !isNaN(t) ) this.topPx = t;
		return this.topPx;
	}

	// いま position を切り替えても見た目が飛ばないか。
	// 追従開始位置より下にいる間は sticky と static の描画が一致するので安全
	canSwitch(){
		return this.el.getBoundingClientRect().top > this.stickyTop();
	}

	apply(shouldStick){
		this.isSticky = shouldStick;
		this.el.classList.toggle('is-sticky', shouldStick);
	}

	// 保留した切り替えを、飛ばない位置まで戻ったところで適用する
	onScroll(){
		if( this.pending === null || !this.canSwitch() ) return;
		this.apply(this.pending);
		this.clearPending();
	}

	clearPending(){
		this.pending = null;
		this.watchScroll(false);
	}

	// 慣性スクロール（Lenis）が入っているとネイティブの scroll が飛ばないことがあるので、
	// Lenis があればそちらも購読する（このサイトの他のコンポーネントと同じ作法）
	watchScroll(on){
		const lenis = window.lenis || (window.app && app.lenis);
		if( on ){
			window.addEventListener('scroll', this.onScroll, { passive: true });
			if( lenis && lenis.on ) lenis.on('scroll', this.onScroll);
		}else{
			window.removeEventListener('scroll', this.onScroll);
			if( lenis && lenis.off ) lenis.off('scroll', this.onScroll);
		}
	}

	render(){
		this.sticky();
		app.Util.resize(()=>{
			this.sticky();
		});
		// 中身の開閉などで自身の高さが変わったときも判定し直す。
		// is-sticky は position を変えるだけで寸法に影響しないのでループしない
		if( typeof ResizeObserver !== 'undefined' ){
			new ResizeObserver(()=>{
				this.sticky();
			}).observe(this.el);
		}
		// 内側にアコーディオンがある場合は開閉後にも判定し直す。
		// ResizeObserver はフレーム駆動なので、描画が止まる環境（非表示タブ等）でも
		// 確実に効くようクリックからも拾う。0.4s の開閉アニメが終わってから測る
		this.el.querySelectorAll('.js-toggle__head').forEach((head)=>{
			head.addEventListener('click', ()=>{
				setTimeout(()=>{ this.sticky(); }, 450);
			});
		});
	}

	sticky(){

		let
			// offset = ( this.el.classList.contains('content__aside') && app.Util.wh() < 768 )? 50 : 100,
			offset = 100,
			size = this.el.offsetHeight + offset;

		if(!this.isFirst && this.el.classList.contains('first')){
			$(window).on('scroll', ()=>{
				// センターにする場合
				if( this.el.classList.contains('center')) {
					let h = this.el.offsetHeight/2,
							pos;
					pos = app.Util.wh()/2 - h;
					this.el.style.top = pos + "px";
				}
			});
			this.isFirst = true;
		}else{
			// センターにする場合
			if( this.el.classList.contains('center')) {
				let h = this.el.offsetHeight/2,
						pos;
				pos = app.Util.wh()/2 - h;
				this.el.style.top = pos + "px";
			}
		}


		const shouldStick = size <= app.Util.wh();

		// 初回は無条件で当てる。まだ何も描いていないので「飛ぶ」ことがないし、
		// スクロール位置が復元された状態で読み込まれても正しい見た目から始められる
		if( !this.initialized ){
			this.initialized = true;
			this.apply(shouldStick);
			return;
		}
		// 変わらないなら何もしない（保留も取り下げる）
		if( shouldStick === this.isSticky ){
			this.clearPending();
			return;
		}
		// 追従中（上端で固定されている最中）に切り替えると、固定位置から本来の位置へ
		// 一気に飛ぶ。アコーディオンを開いて背が高くなったときがこれに当たるので、
		// 飛ばない位置までスクロールが戻ってから適用する
		if( !this.canSwitch() ){
			this.pending = shouldStick;
			this.watchScroll(true);
			return;
		}
		this.clearPending();
		this.apply(shouldStick);
	}
}

export default Sticky;